import { axiosInstance } from "@src/api/axiosConfig";
import { axiosPath } from "@src/api/axiosPath";
import { PRODUCT_SALE_TYPE, TICKET_TYPE } from "@src/components/deungi/common/enum";
import { useQuery } from "react-query";

export const useTicketPackageList = async (saleType: PRODUCT_SALE_TYPE) => {
    const response = await axiosInstance.get(`${axiosPath.ticketPackageList}/${saleType}`);
    return response;
};

export const useQueryTicketPackageListByType = (saleType: PRODUCT_SALE_TYPE) => {
    const fetch = async () => {
        const response = await axiosInstance.get(`${axiosPath.ticketPackageList}/${saleType}`, {
            timeout: 500000,
        });
        return response?.data;
    };

    return useQuery(["getTicketPackageListByType", saleType], fetch, {
        retry: 3,
    });
};
